import { IonButton, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import { CaseHistoryService } from "../../../pages/CaseHistory/CaseHistory.service";
import { PatientFormService } from "../../../pages/PatientForm/PatientForm.service";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import { utilService } from "../../../services/utilService";
import DropDown from "../Dropdown/dropdown-component";
import SearchableDropdown from "../SearchableDropdown/SearchableDropdown";
import "./CaseHistorySiteSelection.scss";
import { useToast } from "@agney/ir-toast";

interface ContainerProps {
  showPatientAlert: boolean;
  showAlert: () => void;
  caseDetails?: any;
  updateCaseDetailsPage?: any;
  isRejected: any;
}
const CaseHistorySiteSelection: React.FC<ContainerProps> = (props: any) => {
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [isEMTUser, checkEMTUser]: any = useState(false);
  const [EMTSites, getEMTSites] = useState([]);
  const [EMTStates, getEMTStates] = useState([]);
  const [EMTCity, getEMTCity] = useState([]);
  const [selectedSiteData, setSelectedSiteData]: any = useState("");
  const [selectedStateData, setSelectedStateData]: any = useState("");
  const [selectedCityData, setSelectedCityData]: any = useState("");
  const [selectedSite, setSelectedSite] = useState<any>(0);
  const [selectedSiteId, setSelectedSiteId] = useState<any>(0);
  const [disableCity, setDisableCity]: any = useState(true);
  const [disableHospital, setDisableHospital]: any = useState(true);
  const [locationData, setLocationData] = useState<any>("");
  const [timeSpanList, setTimeSpanList]: any = useState([]);
  const [selectedETAValue, setSelectedETAValue]: any = useState<any>();
  const [globalId, setGlobalId]: any = useState("");
  const [siteName, setSiteName]: any = useState("");
  const [siteSourceId, setSiteSourceId]: any = useState("");
  const [siteCountryCode, setSiteCountryCode]: any = useState("");
  const [siteTimezone, setSiteTimezone]: any = useState("");
  const [siteLocation, setSiteLocation]: any = useState("");
  const [networkCode, setNetworkCode]: any = useState("");
  const [locationDetails,setLocationDetails] = useState<any>({
    country: {
      global_country_id: "",
      country_name: "",
      country_code: null,
      country_name_code: ""
    },
    state: {
      global_state_id: "",
      state_name: "",
      state_code: "",
    },
    city: {
      global_city_id: "",
      city_name: "",
      city_code: "",
    },
    contact_details:{}
  })

  const Toast = useToast();

  useEffect(() => {
    displayPatientAlert();
    getStateList();
    getETADropDownData();
  }, []);

  let params = {
    reg_code: `${utilService.getNetwork()}`,
  };

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isEmtUser);
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const getETADropDownData = async () => {
    const getETADataList: any = await PatientFormService.getETAList(params);
    if (getETADataList.isSuccess) {
      setTimeSpanList(getETADataList.result);
    } else {
      console.log("error");
    }
  };

  //ETA Selection
  const handleETASelection = (selectedValue: any) => {
    if (selectedValue) {
      let selectedETA: any = timeSpanList.find(
        (selectedETAData: any) => selectedETAData.dataId === selectedValue
      );
      setSelectedETAValue(selectedETA?.dataName);
    }
  };

  const getStateList = async () => {
    const getStateList: any = await PatientFormService.getStateList(params);
    if (getStateList.isSuccess) {
      getEMTStates( getStateList.result?.map((state:any)=>{
        return {
          ...state,
          value:state?.state_code
        }
      }));
    } else {
      console.log("error");
    }
  };

  const handleSiteSelection = (selectedValue: any) => {
    setSelectedSiteData(selectedValue);
    let selectedSite: any = EMTSites.find(
      (selectedSiteData: any) => selectedSiteData.id === selectedValue
    );

    setSelectedSite(selectedSite.site_guid);
    setSelectedSiteId(selectedSite.site_id);
    setGlobalId(selectedSite.id);
    setSiteName(selectedSite.name);
    setSiteSourceId(selectedSite.source_id);
    setSiteCountryCode(selectedSite.country_name_code);
    setSiteTimezone(selectedSite.timezone);
    setSiteLocation(selectedSite.location);
    setNetworkCode(selectedSite.network_code);
    setLocationDetails({
      country:{
        country_code:selectedSite?.country_code,
        country_name:selectedSite?.country_name,
        country_name_code:selectedSite?.country_name_code,
        global_country_id:selectedSite?.global_country_id,
      },
      state: {
        global_state_id: selectedSite?.global_state_id,
        state_name: selectedSite?.state_name,
        state_code: selectedSite?.state_code,
      },
      city: {
        global_city_id: selectedSite?.global_city_id,
        city_name: selectedSite?.city_name,
        city_code: selectedSite?.city_code,
      },
      contact_details:selectedSite?.contact_details
    })
  };

  const handleStateSelection = (selectedValue: any) => {
    setSelectedStateData(selectedValue);
    let selectedState: any = EMTStates.find(
      (selectedStateData: any) => selectedStateData.state_code === selectedValue
    );
    setSelectedStateData(selectedState.state_code);
    getCityList(selectedState.id);
    setDisableCity(false);
  };

  const getCityList = async (selectedValue: any) => {
    let params = selectedValue;
    const getCityList: any = await PatientFormService.getCityList(params);
    if (getCityList.isSuccess) {
      getEMTCity(getCityList.result?.map((city:any)=>{
        return {
          ...city,
          value:city?.city_code          
        }
      }));
      setSelectedCityData("");
      setSelectedSiteData("");
    } else {
      console.log("error");
    }
  };

  const handleCitySelection = (selectedValue: any) => {
    setSelectedCityData(selectedValue);
    let selectedCity: any = EMTCity.find(
      (selectedCityData: any) => selectedCityData.city_code === selectedValue
    );
    setSelectedCityData(selectedCity.city_code);
    getSiteList(selectedCity.id);
    setDisableHospital(false);
  };

  const getSiteList = async (selectedValue: any) => {
    let params = selectedValue;
    const getSitesList: any = await PatientFormService.getSitesList(params);
    if (getSitesList.isSuccess) {
      getEMTSites( getSitesList.result?.map((site:any)=>{
        return {
          ...site,
          value:site?.id         
        }
      }))
      setSelectedSiteData("");
    } else {
      console.log("error");
    }
  };

  const displayPatientAlert = () => {
    setShowModalAlert(true);
  };

  const hidePatientAlert = () => {
    setShowModalAlert(false);
    props.showAlert();
  };

  const submitForm = () => {
    let validationStatus = true;
    if (locationData === "") {
      Toast.error("Please enter patient location to continue");
      validationStatus = false;
    } else if (selectedStateData === "") {
      Toast.error("Please select state to continue");
      validationStatus = false;
    } else if (selectedCityData === "") {
      Toast.error("Please select city to continue");
      validationStatus = false;
    } else if (selectedSite === 0) {
      Toast.error("Please select site to continue");
      validationStatus = false;
    } else if (selectedETAValue === undefined) {
      Toast.error("Please select ETA to continue");
      validationStatus = false;
    }

    if (validationStatus) {
      let params = setParams();
      updateSiteSelection(params);
      hidePatientAlert();
    }
  };

  const setParams = () => {
    const params = {
      reg_code: `${utilService.getNetwork()}`,
      eta: selectedETAValue,
      location: locationData,
      user_guid: utilService.getLoggedUserGuid(),
      patient_guid: props.caseDetails.patient_guid,
      site_guid: selectedSite,
      site_id: selectedSiteId,
      isRejected: props.isRejected,
      global_id: globalId,
      site_name: siteName,
      site_source_id: siteSourceId,
      site_country_code: siteCountryCode,
      site_timezone: siteTimezone,
      site_location: siteLocation,
      site_network_code: networkCode,
      ...locationDetails
    };
    return params;
  };

  // Site selection
  async function updateSiteSelection(formData: any) {
    const updatedSiteResponse: any = await CaseHistoryService.updateSiteDetails(
      formData
    );
    if (updatedSiteResponse.isSuccess) {
      props.updateCaseDetailsPage(props.caseDetails.id);
      Toast.success(CONSTANTS.MESSAGES.EMS_RESENT_REQUEST);
    } else {
      Toast.error(updatedSiteResponse.message);
    }
  }

  return (
    <IonModal
      isOpen={showModalAlert}
      className="site-selection-alert-modal"
      backdropDismiss={false}
    >
      <div className="alert-main-container">
        <div className="content-area">
          <h3 className="label">Update patient case details</h3>
          <div className=""></div>
        </div>
        <form className="case-details-edit-modal">
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">
                Patient Location <span className="ocl-star">*</span>
              </label>
              <input
                type="text"
                className="form-control emt-sac-input"
                maxLength={26}
                id="field-1"
                placeholder="location details"
                value={locationData}
                onChange={(e) => setLocationData(e.target.value)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">
                State <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTStates}
                  value={selectedStateData}
                  placeholder="Select State"
                  onChange={handleStateSelection}
                ></SearchableDropdown>
              </div>
            </div>
            <div
              className={`col-md-12 mb-3 ${disableCity ? "disable-input" : ""}`}
            >
              <label className="ems-form-label">
                City <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTCity}
                  value={selectedCityData}
                  placeholder="Select City"
                  onChange={handleCitySelection}
                ></SearchableDropdown>
              </div>
            </div>
            <div
              className={`col-md-12 mb-3 ${disableHospital ? "disable-input" : ""
                }`}
            >
              <label className="ems-form-label">
                Site <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTSites}
                  value={selectedSiteData}
                  placeholder="Select Site"
                  onChange={handleSiteSelection}
                  isSiteDropDown={true}
                ></SearchableDropdown>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">
                ETA <span className="ocl-star">*</span>
              </label>
              <DropDown
                siteListData={timeSpanList}
                getSelectedItem={(value: number) => {
                  handleETASelection(value);
                }}
                isFromTeams={true}
                dropDownValue="Select ETA"
              ></DropDown>
            </div>
          </div>
          <div className="alert-case-button-container">
            <div className="cancel-button-div">
              <IonButton
                color="medium"
                className="cancel-button secondary-btn button btn-curved"
                onClick={() => {
                  hidePatientAlert();
                }}
              >
                Cancel
              </IonButton>
            </div>
            <div className="send-button-div">
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  submitForm();
                }}
              >
                Update
              </IonButton>
            </div>
          </div>
        </form>
      </div>
    </IonModal>
  );
};

export default CaseHistorySiteSelection;
